import Signals from '@baseUI/controllers/UISignals';
import GameSignals from '@/signals/GameSignals';
import UISignals from '@baseUI/controllers/UISignals';
import UIBaseLayout from '@baseUI/component/base/UIBaseLayout';
import UICreatorGraphics from '@baseUI/utils/UICreatorGraphics';
import BetsSettingsPartContainerPortrait from '@baseUI/component/settings/BetsSettingsPartContainerPortrait';
import UIFacade from '@baseUI/UIFacade';
import UICreatorComponent from '@baseUI/utils/UICreatorComponent';
import AutospinSettingsPartContainerPortrait from '@baseUI/component/settings/AutospinSettingsPartContainerPortrait';
import InfoSettingsPartContainerPortrait from '@baseUI/component/settings/InfoSettingsPartContainerPortrait';
import Facade from '../../../src/Facade';
import SettingsSettingsPartContainerPortrait from '@baseUI/component/settings/SettingsSettingsPartContainerPortrait';

export default class MenuPopupLayout extends UIBaseLayout {
	constructor() {
		super();
		this.setParametersSizePosition();
		this.init();
	}

	setParametersSizePosition() {
		this.param = {
			shadowRect: { x: -600, y: 0, width: 1200, height: 2800 },
			panelPopupPosition: { x: -500, y: 300 },
			closeBtnPosition: { x: 1000, y: 50 },
			panelBtnPosition: { x: 100, y: 10 },
			listButtonsPosition: { ax: 100, bx: 130, ay: 0, by: 0 },
			panelAdditionalPosition: { x: 20, y: 300 },
		};
	}

	init() {
		UISignals.setStateMenu.add(this.onChangeMenu.bind(this));
		document.addEventListener('menuPopup', this.onShowPage.bind(this));
		Signals.builtAll.add(this.onBuiltAll, this);
		UICreatorGraphics.addShadow(this, this.param.shadowRect);

		// For the integration
		document.addEventListener('open', (event) => {
			if (event.detail && event.detail.name === 'paytable') {
				UISignals.setStateMenu.dispatch('menuInfo');
			}
		});

		document.addEventListener('close', (event) => {
			if (event.detail && event.detail.name === 'paytable') {
				this.hideAllPart();
				this.hide();
			}
		});
	}

	onBuiltAll() {
		const panelPopup = UICreatorComponent.addContainer(
			this,
			this.param.panelPopupPosition
		);
		Signals.orientationChanged.add(this.onOrientationChanged, this);

		this.createButtons(panelPopup);
		this.createImplementationMenu(panelPopup);
		this.createCloseButton(panelPopup);
	}

	createCloseButton(panelPopup) {
		this.closeBtn = UICreatorComponent.addButtonHitArea(
			'settingClose_BUTTON',
			panelPopup,
			this.param.closeBtnPosition
		);
		this.closeBtn.on('tapButton', () => {
			this.hide();
			this.hideAllPart();
		});
	}

	createButtons(panelPopup) {
		this.panelBtn = UICreatorComponent.addContainer(
			panelPopup,
			this.param.panelBtnPosition
		);

		this.menutButtons = [];

		let listButtons = [
			'menuBet',
			'menuAutoplay',
			'menuInfo',
			'menuBetHistory',
			'menuSettings',
			'menuHome',
		];
		if (!UIFacade.model.isAutospinShow) {
			listButtons.splice(
				listButtons.findIndex((name) => {
					return name === 'menuAutoplay';
				}),
				1
			);
		}

		if (!UIFacade.model.historyUrl) {
			listButtons.splice(
				listButtons.findIndex((name) => {
					return name === 'menuBetHistory';
				}),
				1
			);
		}

		const ax = this.param.listButtonsPosition.ax;
		const bx = this.param.listButtonsPosition.bx;
		const ay = this.param.listButtonsPosition.ay;
		const by = this.param.listButtonsPosition.by;
		listButtons.map((key, index) => {
			const btn = UICreatorComponent.addListenerStateOneButton(
				key + '_STATE',
				key,
				this.panelBtn,
				[ax + bx * index, ay + by * index]
			);
			btn.name = key;
			this.menutButtons.push(btn);
		});
	}

	createImplementationMenu(panelPopup) {
		const panelAdditional = UICreatorComponent.addContainer(
			panelPopup,
			this.param.panelAdditionalPosition
		);

		this.betPopup = new BetsSettingsPartContainerPortrait();
		panelAdditional.addChild(this.betPopup);
		this.betPopup.visible = true;

		this.autospinPopup = new AutospinSettingsPartContainerPortrait();
		panelAdditional.addChild(this.autospinPopup);
		this.autospinPopup.visible = false;

		this.infoPopup = new InfoSettingsPartContainerPortrait();
		panelAdditional.addChild(this.infoPopup);
		this.infoPopup.visible = false;

		this.settingsPopup = new SettingsSettingsPartContainerPortrait();
		panelAdditional.addChild(this.settingsPopup);
		this.settingsPopup.visible = false;

		this.panelAdditional = panelAdditional;
	}

	onChangeMenu(nameMenu) {
		this.menutButtons.map((btn) => {
			if (btn.name === nameMenu) {
				btn.enable();
			} else {
				btn.disable();
			}
		});
		this.show();

		switch (nameMenu) {
			case 'closeMenu':
				this.hideAllPart();
				this.hide();
				break;
			case 'menuAutoplay':
				this.showPage('autoplayPage');
				break;
			case 'menuBet':
				this.showPage('betPage');
				break;
			case 'menuInfo':
				this.showPage('infoPage');
				break;
			case 'menuSettings':
				this.showPage('settingsPage');
				break;
			case 'menuHome':
				if (this.shouldRedirect()) {
					GameSignals.quitHandler.dispatch();

					let url = UIFacade.model.lobbyURL;
					const lookupHTTP = url.substr(0, 'http'.length);
					if (lookupHTTP !== 'http') {
						url = `https://${url}`;
					}
					window.open(url, '_top');
					// document.dispatchEvent(new CustomEvent('tap', {detail: {name: 'home'}}))
				}
				break;
			case 'menuBetHistory':
				window.open(UIFacade.model.historyUrl, '_blank');
				break;
		}
	}

	shouldRedirect() {
		if (Facade.urlParams.customer === 'egt') {
			this._send('exit');
			return false;
		}

		return true;
	}

	_send(event) {
		const message = { event: event };
		window.parent.postMessage(JSON.stringify(message), '*');
		console.log('::: PostMessageAPI sent', message);
	}

	onShowPage(e) {
		this.showPage(e.detail.page);
	}

	showPage(namePage) {
		this.hideAllPart();
		switch (namePage) {
			case 'autoplayPage':
				this.autospinPopup.show();
				// this.autoplayBtn.disabled = false
				break;
			case 'betPage':
				this.betPopup.show();
				break;
			case 'infoPage':
				this.infoPopup.show();
				break;
			case 'settingsPage':
				this.settingsPopup.show();
				break;
		}
	}

	hideAllPart() {
		this.autospinPopup.hide();
		this.betPopup.hide();
		this.infoPopup.hide();
		this.settingsPopup.hide();
	}

	updateSize(uiModelView) {
		this.betPopup.updateSize(uiModelView);
		this.autospinPopup.updateSize(uiModelView);
		this.infoPopup.updateSize(uiModelView);
		this.settingsPopup.updateSize(uiModelView);
	}

	hide() {
		super.hide();
		UIFacade.model.showSettings = false;
	}

	show() {
		super.show();

		this.menutButtons.forEach((button) => {
			if (button.name === 'menuHome' && !UIFacade.model.lobbyURL) {
				button.visible = false;
			} else {
				button.visible = true;
			}
		});

		UIFacade.model.showSettings = true;
	}

	onOrientationChanged(orientationSymbol) {
		UIFacade.model.showSettings ? this.show() : this.hide();
	}

	updateText() {
		this.infoPopup.updateText();
	}
}
